import React, { useState } from 'react';
import { Button } from '@components';
import Modal from '@modules/Modal/Modal';
import { t } from 'ttag';

export default function Terms() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ title: '', content: '' });
  const [isImprintAvailable, setIsImprintAvailable] = useState(false);

  const fetchAndOpenModal = async (endpoint, title) => {
    const response = await fetch(endpoint);
    if (!response.ok) {
      return undefined;
    }
    const data = await response.json();
    setModalData({ title, content: data.text });
    setIsModalOpen(true);
    return undefined;
  };

  const handleOpenTerms = () => {
    fetchAndOpenModal('/api/policies/term/', t`Terms and Conditions`);
  };

  const handleOpenPrivacyPolicy = () => {
    fetchAndOpenModal('/api/policies/privacy/', t`Privacy Policy`);
  };

  const handleOpenImprint = () => {
    fetchAndOpenModal('/api/policies/imprint/', t`Imprint`).catch(() => {
      setIsImprintAvailable(false);
    });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <section className="flex min-h-[40px] items-center px-3 py-4 lg:px-0">
      <Button
        aria-label="Terms and Conditions"
        variant="tertiary"
        className="p-0 text-xs font-semibold text-white hover:underline"
        onClick={handleOpenTerms}
      >
        <Button.Text className="text-xs font-semibold text-white hover:underline">
          {t`Terms and Conditions`}
        </Button.Text>
      </Button>
      <div className="mx-6 h-3 w-px bg-white" />
      <Button
        aria-label="Privacy Policy"
        variant="tertiary"
        className="p-0 text-xs font-semibold text-white hover:underline"
        onClick={handleOpenPrivacyPolicy}
      >
        <Button.Text className="text-xs font-semibold text-white hover:underline">
          {t`Privacy Policy`}
        </Button.Text>
      </Button>

      {isImprintAvailable && (
        <>
          <div className="mx-6 h-3 w-px bg-white" />

          <Button
            aria-label="Imprint"
            variant="tertiary"
            className="p-0 text-xs font-semibold text-white hover:underline"
            onClick={handleOpenImprint}
          >
            <Button.Text className="text-xs font-semibold text-white hover:underline">
              {t`Imprint`}
            </Button.Text>
          </Button>
        </>
      )}

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <article className="md:prose-md prose prose-sm overflow-x-hidden sm:prose-sm lg:prose-lg">
          <div dangerouslySetInnerHTML={{ __html: modalData.content }} />
        </article>
      </Modal>
    </section>
  );
}
